var PD = PD || {};
PD.forms = PD.forms || {};
PD.forms.fields = (function(f){
  f._aliases = {}; // map of alias -> class
  /**
   * Register a new field type for use with PD.forms.Form.
   * Also makes the new field class inherit from the generic _Field class
   * @param  {Array|String} aliases  List of names the field is identified by
   * @param  {Function} classs       The fields "class" (constructor function)
   * @param  {Function} type         If given, the generic class to extend (eg. TextField)
   */
  f.register = function(aliases, classs, type) {
    // register alias' in our map
    aliases = [].concat(aliases); // make sure aliases is an array
    for (var i = 0; i < aliases.length; ++i) {
      var alias = aliases[i];
      if (f._aliases.hasOwnProperty(alias)) {
        console.warn("[PD.forms.fields] Registering a new field (",classs,") using an alias ("+alias+") that belongs to another field (",f._aliases[alias],").");
      }
      f._aliases[aliases[i]] = classs;
    }

    // inherit from our main Field class or the generic class
    PD.utils.extend(classs, type || _Field);
  };



  /**
   * Generic field class. Implements basic field methods.
   * Shouldn't be instantiated from outside, only used as type for .register
   */
  function _Field(cfg, index, form){
    this.id = cfg.id ||
              ((form && form.name) || cfg.name || "") + // format: [form-name]-field-[index]
                "-field-"+PD.utils.unique();
    this.index = index;
    this.form = form;
    this.$elm = $();

    $.extend(this, cfg);
    if (!this.name) {
      // console.warn("[PD.forms.fields.Field] Instantiated field without name",this);
    }
  }
  _Field.prototype = {
    label: "",
    placeholder: null,
    name: "",
    mandatory: false,
    shouldValidate: true,
    helpText: false,
    inlineHelpText: false,
    errorText: false,
    readOnly: false,
    value: null,

    _rows: 1,
    _tabs: 1,
    _template: "",

    _get$Element: function(){
      if (!this.$elm.length) {
        this.$elm = $( $.tmpl( this._template, this ) );
      }
      this.$label = $("label.control-label", this.$elm);

      $('[data-toggle="popover"]',  this.$elm).popover({
        placement: "left",
        container: "body",
        html: true
      });

      return this.$elm;
    },
    on: function(){
      this.$elm.on.apply(this.$elm, arguments);
    },
    _setFeedback: function() {},
    validate: function(){ return true; },
    getValue: function(){ return null; },
    setValue: function(value){ return true; },
    setLabel: function(label){
      label = label ? label+":" : "";
      this.label = label;
      this.$label.text(label);
    },
    clearValue: function(){ return true; }
  };



  /**
   * Generic text input field class.
   * See above.
   * Having it in fields.js isn't pretty, but necesarry 
   * to ensure it's loaded when other fields are registered
   */
  function TextField(cfg, index, form) {
    TextField.prototype._super.apply(this, arguments); // call generic field constructor
  }
  TextField.prototype = {
    _rows: 0,
    _template: 
      '<div class="form-group">' +
        '<label for="<%=id%>" class="col-sm-3 control-label"><%=label?label+\':\':\'\'%></label>' +
        '<div class="col-sm-<%=helpText? "8" : "9"%>">' +
          '<input type="text" class="form-control" <%=value?\'value="\'+value+\'"\':""%> id="<%=id%>" name="<%=name%>" placeholder="<%=placeholder===false? \'\' : placeholder || label%>"<%=readOnly ? " readonly" : ""%>>' +
        '</div>' +
      '<% if (helpText) { %>' +
        '<div class="col-sm-1 hidden-xs">' +
          '<i class="far fa-question-circle" role="button" data-toggle="popover" title="<%=helpText.title%>" data-content="<%=helpText.content%>"></i>'+
        '</div>' +
      '<% } %>' +
      '<% if (errorText) { %>' +
        '<div class="col-sm-9 col-sm-offset-3 error-text">' +
          '<p><%=errorText%></p>' +
        '</div>' +
      '<% } %>' +
      '<% if (inlineHelpText) { %>' +
        '<div class="col-sm-9 col-sm-offset-3 help-block">' +
          '<p><%=inlineHelpText%></p>' +
        '</div>' +
      '<% } %>' +
      '</div>',
    _feedback: null,
    regex: null,
    onChange: null,

    _get$Element: function(){
      TextField.prototype._super.prototype._get$Element.apply(this, arguments);

      // bind specific listeners to our element
      this.$inp = $("#"+this.id,this.$elm);
      // validate on blur
      this.$inp.on("blur", this.validate.bind(this));
      var self = this,
          _debouncedValidate = __.debounce(function(){
            self.validate();
          }, 500);

      // TODO: Check for "soft feedback"
      this.$inp.on("input", function(){
        if (self._feedback) {
          self._setFeedback("");
        }
        if (self.onChange) {
          self.onChange(self.getValue());
        }
        _debouncedValidate();
      });
      return this.$elm;
    },
    getValue: function(){
      return this.$inp.val();
    },
    setValue: function(val){
      this.$inp.val(val);
      return true;
    },
    clearValue: function(){
      this.$inp.val("");
      return true;
    }
  };
  // Show feedback to the user
  TextField.prototype._setFeedback = function(feedback) {
    // TODO: figure out what $fmc is in the original and ensure that $fg === this.$elm
    if (this._feedback !== feedback) {
      // remove existing feedback
      this.$elm.find(".form-control-feedback").remove();
      this.$elm.removeClass("has-warning has-error has-feedback");
      // add new feedback
      if (feedback) {
        var type = feedback === "error" ? "error" : "warning";
        var icon = feedback === "mandatory" ? "asterisk" : "exclamation";
        this.$elm.addClass("has-feedback has-"+type);
        this.$inp.before("<i class='fa fa-"+icon+" form-control-feedback'></i>");
      }
      this._feedback = feedback;
    }
  };
  /// Checks if a value is valid - used by .validate
  TextField.prototype._checkValue = function(val) {
    if (val === "") {
      return null;
    }
    var valid = true;
    if ($.isNumeric(this.minLength)) {
      valid = valid && val.length >= this.minLength;
    }
    if ($.isNumeric(this.maxLength)) {
      valid = valid && val.length <= this.maxLength;
    }
    if (this.regex) {
      valid = valid && this.regex.test(val);
    }

    return valid;
  };
  // Validate the textfield, showing feedback to user
  TextField.prototype.validate = function() {
    var valid = true, feedback;
    
    if (this.shouldValidate === true) {
      valid = this._checkValue(
        this.getValue()
      );
      
      if (valid === null) { // value was empty
        if (this.mandatory === true) {
          feedback = "mandatory";
          valid = false;
        } else {
          valid = true;
        }
      } else if (valid === false) {
        feedback = "error";
      }
      
      this._setFeedback(feedback);
    }

    return valid;
  };
  // register generic TextField so it can be used as normal field
  f.register(["text", "TextField"], TextField);
  f.TextField = TextField;

  return f;
})(PD.forms.fields || {});
